import { PaymentMethodMutationResponse } from '@sola/schema/dotcom/proxy-api/paymentMethods.ts';
import type { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { userErrorBadParam } from '@sola/shared-utils/errors/misc.ts';
import { userErrorPaymentMethodAssignToCommitment } from '@sola/shared-utils/errors/supporters.ts';
import { httpPutWithStatus } from '@sola/shared-utils/httpClient.ts';

import { MY_API_BASE } from '../constants.ts';

export interface CommitmentPaymentPlanUpdateRes {
  commitmentUpdates?: PaymentMethodMutationResponse['commitmentUpdates'];
  success: boolean;
}

export const routeCommitmentPaymentPlan = (
  supporterId: string,
  commitmentId: string,
) =>
  `${MY_API_BASE}/supporters/${supporterId}/commitments/${commitmentId}/payment-plan/`;

export const updateCommitmentPaymentPlan = async (
  supporterId?: string,
  commitmentId?: string,
  newPaymentMethodId?: GraphQLSupporterPaymentMethod['id'],
  paymentDay?: number,
): Promise<CommitmentPaymentPlanUpdateRes> => {
  if (!supporterId) {
    throw userErrorBadParam('supporterId');
  }

  if (!commitmentId) {
    throw userErrorBadParam('commitmentId');
  }

  if (!newPaymentMethodId) {
    throw userErrorBadParam('newPaymentMethodId');
  }

  const { response, statusCode } =
    await httpPutWithStatus<CommitmentPaymentPlanUpdateRes>(
      routeCommitmentPaymentPlan(supporterId, commitmentId),
      {
        paymentMethodId: newPaymentMethodId,
        paymentPullDay: paymentDay,
      },
      {
        signRequest: true,
      },
    );

  if (statusCode !== 200 || !response?.success) {
    throw userErrorPaymentMethodAssignToCommitment(statusCode);
  }

  return response;
};
